import React, { useEffect } from 'react';
import { Form, Input, Select, message } from 'antd';
import { UpsertModal } from '../../../components/Templates/UpsertModal';
import { teamApi } from '../../../services/team/team';
import type { TeamEntity } from '../../../types/team/team';

interface TeamUpsertModalProps {
  open: boolean;
  mode: 'create' | 'edit';
  record: TeamEntity | null;
  staffs: any[];
  shops: any[];
  onCancel: () => void;
  onSuccess: () => void;
}

const statusOptions = [
  { label: '启用', value: 1 },
  { label: '禁用', value: 0 },
];

export const TeamUpsertModal: React.FC<TeamUpsertModalProps> = ({
  open,
  mode,
  record,
  staffs,
  shops,
  onCancel,
  onSuccess,
}) => {
  const formFields = [
    { name: 'name', label: '团队名称', type: 'text' as const, required: true, rules: [{ required: true, message: '请输入团队名称' }] },
    {
      name: 'leaderId',
      label: '团队负责人',
      type: 'select' as const,
      required: true,
      rules: [{ required: true, message: '请选择团队负责人' }],
      options: staffs.map(s => ({ label: s.name, value: s.id })),
      fieldProps: { showSearch: true, optionFilterProp: 'label' }
    },
    { name: 'teamInfo', label: '团队信息', type: 'textarea' as const, required: false },
    {
      name: 'shopIds',
      label: '负责店铺',
      type: 'select' as const,
      required: true,
      rules: [{ required: true, message: '请选择负责店铺' }],
      options: shops.map(s => ({ label: s.name, value: s.id })),
      fieldProps: { mode: 'multiple', showSearch: true, optionFilterProp: 'label' }
    },
    {
      name: 'staffIds',
      label: '团队成员',
      type: 'select' as const,
      required: true,
      rules: [{ required: true, message: '请选择团队成员' }],
      options: staffs.map(s => ({ label: s.name, value: s.id })),
      fieldProps: { mode: 'multiple', showSearch: true, optionFilterProp: 'label', placeholder: '请选择成员（仅展示审核角色员工）' }
    },
    { name: 'status', label: '状态', type: 'select' as const, required: true, options: statusOptions, initialValue: 1 },
  ];

  return (
    <UpsertModal<TeamEntity>
      title={mode === 'create' ? '新增团队' : '编辑团队'}
      open={open}
      mode={mode}
      record={record}
      onCancel={onCancel}
      onSuccess={onSuccess}
      createApi={(data) => teamApi.create(data)}
      updateApi={(id, data) => teamApi.updateById(id, data)}
      formFields={formFields}
    />
  );
};

export default TeamUpsertModal;
